import uniq from 'lodash/uniq'
import type {
  AddressBookEntryDto,
  BusinessUnitCode,
  CountryCode,
  TransportType,
  HandOffMethodDto,
  ReturnType,
} from '~/model'

export type ReturnPortal = {
  customerPortalId: string
  address: AddressBookEntryDto
  logo?: string
  handoffMethods: HandOffMethodDto[]
  businessUnitCode: BusinessUnitCode
}

export const useEveningTimeWindows = ({ handoffMethods }: ReturnPortal) =>
  handoffMethods.some((hm) => hm.handOffMethod === 'consumer_pickup' && hm.options?.includes('evening_timeslot'))

export const allowTransportType = (
  { handoffMethods }: ReturnPortal,
  transportType: TransportType,
  countryCode: CountryCode
) => {
  switch (transportType) {
    case 'parcel':
      return handoffMethods.some(
        (hm) =>
          (hm.handOffMethod === 'consumer_pickup' ||
            hm.handOffMethod === 'service_point' ||
            hm.handOffMethod === 'pickup') &&
          hm.allowedCountries.includes(countryCode)
      )
    case 'pallet':
      return handoffMethods.some((hm) => hm.handOffMethod === 'pickup' && hm.allowedCountries.includes(countryCode))
    default:
      return false
  }
}

export const allowReturnType = ({ handoffMethods }: ReturnPortal, returnType: ReturnType, countryCode: CountryCode) =>
  handoffMethods.some((hm) => hm.handOffMethod === returnType && hm.allowedCountries.includes(countryCode))

const countriesWithLabelType: CountryCode[] = ['NL']
export const allowLabelType = ({ handoffMethods }: ReturnPortal, countryCode: CountryCode) =>
  handoffMethods.some((hm) => hm.handOffMethod === 'service_point' && hm.allowedCountries.includes(countryCode)) &&
  countriesWithLabelType.includes(countryCode)

export const allowedHandoffCountries = ({ handoffMethods }: ReturnPortal) => {
  const allowedHandoffMethodCountries = handoffMethods.flatMap((hm) => hm.allowedCountries)
  return uniq<CountryCode>(allowedHandoffMethodCountries)
}
